var map = {
	"./mobile/data.vue": [
		"067b",
		"chunk-3e1b9214",
		"chunk-207c68f2",
		"chunk-2fa04b33"
	],
	"./pc/data.vue": [
		"7580",
		"chunk-3e1b9214",
		"chunk-207c68f2",
		"chunk-75f9f68e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5d7e";
module.exports = webpackAsyncContext;